import { createActions, createReducer } from 'reduxsauce'

import ConsultaContratoService from '../../servicos/ConsultaContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaContratoInicio: [],
    buscaConsultaContratoSucesso: ['consultaContrato'],
    buscaConsultaContratoErro: ['erro'],
    limpar: [],
    setConsultaContratoEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaContrato = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaContratoInicio())
        let serv = new ConsultaContratoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaContratoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaContratoErro(error)))
    }
}

const buscaConsultaContratoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaContratoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaContratoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.consultaContrato.resultado, dataSincronizacaoDados: action.consultaContrato.dataSincronizacaoDados, carregando: false }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaContratoEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_CONTRATO_INICIO]: buscaConsultaContratoInicio,
    [Types.BUSCA_CONSULTA_CONTRATO_ERRO]: buscaConsultaContratoErro,
    [Types.BUSCA_CONSULTA_CONTRATO_SUCESSO]: buscaConsultaContratoSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_CONTRATO_ESTADO_DT]: setConsultaContratoEstadoDT,
})
